import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store?.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const isHeaderVisible = state => selectState(state).headerVisible;
export const selectModals = state => selectState(state).modals;

export const selectModalById = (id, state) => {
  const modals = selectModals(state);
  const findModal = modals.find(modal => modal.id === id);
  return findModal;
};
